import { render, staticRenderFns } from "./BrandUnit.vue?vue&type=template&id=c6863fb8&"
import script from "./BrandUnit.vue?vue&type=script&lang=js&"
export * from "./BrandUnit.vue?vue&type=script&lang=js&"
import style0 from "./BrandUnit.vue?vue&type=style&index=0&id=c6863fb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports